
export default function BrandIntro() {
  const features = [
    { icon: 'ri-tools-line', text: '室內裝修統包' },
    { icon: 'ri-drop-line', text: '浴室改造' },
    { icon: 'ri-home-smile-line', text: '舊屋翻修改造' },
    { icon: 'ri-palette-line', text: '居家軟裝設計' },
    { icon: 'ri-key-line', text: '出租裝修服務' },
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <span className="text-sm font-medium text-primary uppercase tracking-wider">我們的理念</span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-primary mb-8 font-serif leading-tight">
            我們相信<br />
            家，不只是住的地方，而是生活的開始
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            GELi 閣立專注於<strong className="text-primary">舊屋改造</strong>與<strong className="text-primary">整合改造</strong>，<br />
            從施工到軟裝搭配，協助屋主打造真正可以入住的家。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mt-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 bg-warm-50 rounded-2xl hover:bg-primary/5 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-4 group-hover:bg-primary group-hover:text-white transition-all shadow-sm">
                <i className={`${feature.icon} text-2xl text-primary group-hover:text-white`}></i>
              </div>
              <p className="text-sm font-medium text-gray-800 leading-relaxed">
                {feature.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
